import { Flow } from '@/components/Flow';
import { Step } from '@/components/Step';

export const Error = () => {
  return (
    <Flow>
      <Flow.StepList>
        <Step name='error' />
      </Flow.StepList>
    </Flow>
  );
};
